export const container = ({ theme: { colors, transition } }) => ({
    '& a': {
        color: colors.blue,

        transition,
        transitionProperty: 'color',

        ':hover': {
            color: colors.fuchsia,
        },
    },
});
